import WebsiteModal from "modal/WebsiteModal";
import {svg_include} from "../index";

export default class RegionModal extends WebsiteModal {
    constructor($elem) {
        super();

        this.$element = $elem;
        this.key = this.$element.attr('data-key');

        try {
            this.region_data = JSON.parse($(".js-regions").text())[this.key];
        } catch (e) {
            console.warn("Couldn't load data from page", e);
        }
    }

    cleanWebsiteUrl(url) {
        url = url.replace(/^https?:\/\//, '');
        url = url.replace(/\/$/, "")
        return url;
    }

    buildModal() {
        let $contacts = false;

        if ('undefined' !== typeof this.region_data.contacts) {
            $contacts = this.region_data.contacts.map((contact) => {
                return (
                    eotwJSXFactory('div', {className: "contact-details"}, [
                        eotwJSXFactory('div', {className: "contact-details__heading"}, [
                            eotwJSXFactory('h3', {className: "heading heading--4"}, ['undefined' !== typeof contact.name ? contact.name : ''])
                        ]),
                        eotwJSXFactory('div', {className: "contact-details__content"}, [
                            eotwJSXFactory('p', null, ['undefined' !== typeof contact.address_line_1 ? contact.address_line_1 : '', eotwJSXFactory('br'),
                                'undefined' !== typeof contact.address_line_2 ? contact.address_line_2 : ''])
                        ]),
                        eotwJSXFactory('div', {className: "contact-details__content contact-details__content--details"}, [
                            'undefined' !== typeof contact.telephone_number && contact.telephone_number !== '' ? (eotwJSXFactory('a', {className: "icon-link", href: "tel:" + contact.telephone_number}, [eotwJSXFactory('span', {className: "icon-link__icon", unsafeHtml: (svg_include('tel-icon'))}),contact.telephone_number])) : '',
                            'undefined' !== typeof contact.telephone_number_alt && contact.telephone_number_alt !== '' ? (eotwJSXFactory('a', {className: "icon-link", href: "tel:" + contact.telephone_number_alt}, [eotwJSXFactory('span', {className: "icon-link__icon", unsafeHtml: (svg_include('tel-icon'))}),contact.telephone_number_alt])) : '',
                            'undefined' !== typeof contact.email_address && contact.email_address !== '' ? (eotwJSXFactory('a', {className: "icon-link", href: "mailto:" + contact.email_address}, [eotwJSXFactory('span', {className: "icon-link__icon", unsafeHtml: (svg_include('email-icon'))}),contact.email_address])) : '',
                            'undefined' !== typeof contact.website && contact.website !== '' ? (eotwJSXFactory('a', {className: "icon-link", target: "_blank", rel: "noreferrer", href: contact.website}, [eotwJSXFactory('span', {className: "icon-link__icon", unsafeHtml: (svg_include('website-icon'))}),this.cleanWebsiteUrl(contact.website)])) : ''
                        ])
                    ])
                );
            });
        }

        this.$modal = (
            eotwJSXFactory('div', {className: "modal js-modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "modal__box modal__box--small"}, [
                        eotwJSXFactory('div', {className: "modal__close js-close-modal"}),
                        eotwJSXFactory('div', {className: "heading-section heading-section--900"}, [
                            eotwJSXFactory('div', {className: "heading heading--sub-heading heading--primary"}, ["Contact"]),
                            eotwJSXFactory('h2', {className: "heading heading--2"}, ['undefined' !== typeof this.region_data.title ? this.region_data.title : '', " contact details"])
                        ]),
                        eotwJSXFactory('div', {className: "scroll-content"}, [
                            $contacts
                        ])
                    ])
                ])
            ])
        );
    }

    buildElement() {
        this.buildModal();
    }
}
